import {NgIf} from '@angular/common';
import {Component, Inject, OnInit, signal} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef, MatDialogModule} from '@angular/material/dialog';
import {
  UntypedFormControl,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {MatRadioModule} from '@angular/material/radio';
import {
  DialogCloseButtonComponent,
  InfoMessageComponent,
  PrimaryButtonComponent,
  SecondaryButtonComponent
} from '@q9elements/ui-kit/components';
import {RequestsService} from '../../../core/requests/requests.service';

export enum DisplayChangeScope {
  DIAGRAM = 'diagram',
  CHILDREN = 'children'
}

@Component({
  selector: 'app-change-diagram-theme',
  templateUrl: './change-diagram-theme.component.html',
  styleUrls: ['./change-diagram-theme.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatRadioModule,
    TranslateModule,
    InfoMessageComponent,
    SecondaryButtonComponent,
    PrimaryButtonComponent,
    DialogCloseButtonComponent,
    NgIf
  ]
})
export class ChangeDiagramThemeComponent implements OnInit {
  public form: UntypedFormGroup;
  public isLoading = signal(false);
  public error: string | null = null;

  protected readonly changeScope = DisplayChangeScope;

  constructor(
    @Inject(MAT_DIALOG_DATA) private passedData: any,
    private dialogRef: MatDialogRef<ChangeDiagramThemeComponent>,
    private requestSvc: RequestsService
  ) {}

  ngOnInit() {
    this.form = new UntypedFormGroup({
      radio: new UntypedFormControl(DisplayChangeScope.DIAGRAM)
    });
  }

  get requestPayload() {
    return {scope: this.form.get('radio').value};
  }

  public async applyTheme() {
    if (this.isLoading()) {
      return;
    }

    const task = {
      isApi: true,
      url: `/diagram/${this.passedData.diagramId}/state/draft/theme/${this.passedData.passedThemeId}`,
      method: 'PUT',
      data: this.requestPayload
    };

    try {
      this.isLoading.set(true);
      await this.requestSvc.addToQueue(task, true);
      this.dialogRef.close(true);
    } catch (error) {
      if (error.error.status === 'theme.err.not_found') {
        this.error = 'POPUPS.THEME_NOT_FOUND';
      }
    } finally {
      this.isLoading.set(false);
    }
  }
}
